export const APP_ID = 'wxa09aa298d23a4753';